import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as DocumentImagesSvg } from '../../assets/scan-document-icon.svg';

export const DocumentImageIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocumentImagesSvg} {...props} />;
};
